export function downloadDataAsFile(data = '', filename = 'download.txt', options = {}) {
  options = {
    type: 'text/plain',
    ...options,
  }

  // File and Blob constructors expect an Array-like object
  if (!Array.isArray(data)) {
    data = [data]
  }

  let file = null
  try {
    file = new File(data, filename, options)
  } catch {
    // Fall back to Blob constructor if File constructor isn't supported.
    file = new Blob(data, options)
  }

  // This download method allows us to specify a filename; directly setting the window's location does NOT
  const a = document.createElement('a')
  a.href = URL.createObjectURL(file)
  a.download = filename
  a.click()
}

export function downloadDataAsCsv(data, filename, options = {}) {
  options = {
    type: 'text/csv',
    ...options,
  }

  downloadDataAsFile(data, filename, options)
}

export function parseFilenameFromContentDisposition(contentDisposition = '', normalized = true) {
  let filename = contentDisposition.substring(contentDisposition.indexOf('filename=') + 9)
  if (filename.startsWith('"') && filename.endsWith('"')) {
    filename = filename.substring(1, filename.length - 1)
  }
  if (normalized) {
    filename = filename.replace(/[^a-z0-9_.-]/gi, '_')
  }
  return filename
}

export function selectFile(mimeTypes = ['*/*']) {
  return new Promise((fulfill, reject) => {
    try {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = mimeTypes.join(',')
      input.onchange = function () {
        fulfill(this.files[0])
      }
      input.click()
    } catch (error) {
      reject(error)
    }
  })
}

export function selectFiles(mimeTypes = ['*/*']) {
  return new Promise((fulfill, reject) => {
    try {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = mimeTypes.join(',')
      input.multiple = true
      input.onchange = function () {
        fulfill(this.files)
      }
      input.click()
    } catch (error) {
      reject(error)
    }
  })
}

export function isFileOfType(fileOrEvent, mimeTypes, extension) {
  const file = fileOrEvent instanceof Event ? fileOrEvent.dataTransfer.files[0] : fileOrEvent
  // Make sure the file is of the correct type; if not, return early
  // Browsers on Windows OS detect file type for CSV files differently than *nix OS's.
  // On Windows, `fileToUpload.type` may be an empty string or application/vnd.ms-excel if Excel is installed
  // As a workaround, check the extension of the file name when the mime type is unexpected
  return (
    mimeTypes.includes(file.type.toLowerCase()) ||
    file.name.trim().toLowerCase().endsWith(extension)
  )
}
